<template>
  <div class="p-formgrid p-grid">  

    <TabView>
      <TabPanel header="Horários" class="p-mt-3">

         <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="descricaoCiclo">Ciclo de revezamento <span class="campo-obrigatorio">*</span></label>
            <Dropdown v-model="idCicloSelecionado" dataKey="id" :options="ciclosSelecao" optionLabel="descricao" optionValue="id" placeholder="Selecione" @change="listarSequenciaCiclos"/>             
          </div>					
        </div>   

        <div class="p-field p-col-12 p-md-6 ">
          <DataTable :value="diasDaEscala" class="p-datatable-sm p-datatable-striped">				
            <Column field="diaDe" header="Dia"></Column>
            <Column field="entrada1" header="1ª Entrada"></Column>	
            <Column field="saida1" header="1ª Saída"></Column>	
            <Column field="entrada2" header="2ª Entrada"></Column>	
            <Column field="saida2" header="2ª Saída"></Column>	
            <Column field="entrada3" header="3ª Entrada"></Column>	
            <Column field="saida3" header="3ª Saída"></Column>	
          </DataTable>
        </div>   

        <div class="p-field p-col-12 p-md-12 p-mt-2">
          <h6 class="p-text-bold">Refeição/Intervalo</h6>
          <hr/>
          <div class="p-formgroup-inline">
            <div class="p-field-radiobutton">
              <RadioButton id="parametroRefeicao1" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="2" @click="validarOpcaoIntervalo(2)"/>
              <label>Marcação inexistente</label>
            </div>
            <div class="p-field-radiobutton">
              <RadioButton id="parametroRefeicao2" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="3" @click="validarOpcaoIntervalo(3)"/>
              <label>Marcação pré-assinalada</label>
            </div>
            <div class="p-field-radiobutton">
              <RadioButton id="parametroRefeicao3" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="4" @click="validarOpcaoIntervalo(4)"/>
              <label>Marcação flexível</label>
            </div>
          </div>
        </div>

        <div class="p-field p-col-12 p-md-12" v-if="exibirMensagemOpcaoIntervalo">
            <Message severity="warn">{{ mensagemOpcaoIntervalo }}</Message>
        </div>

        <div class="p-field p-col-12 p-md-12">
          <h6 class="p-text-bold">Lanche</h6>
          <div class="p-field-checkbox">
            <Checkbox v-model="descontarSegundoIntervalo" :binary="true"/>
            <label>Descontar o segundo intervalo</label>
          </div>
        </div>

        <div class="p-field p-col-12 p-md-12">
          <h6 class="p-text-bold">Fechamento</h6>        
          <hr/>   
          <div class="p-formgroup-inline">
            <div class="p-field p-col-12 p-md-12">
                <Message severity="warn" :sticky="true" :closable="false">
                    Atenção! <br/>
                    Selecione com cuidado o Horário Noturno.<br/>
                    Caso o horário de saída seja próximo da meia-noite ou ultrapasse esse horário, selecione esta opção.<br/>
                    Além disso, defina a quantidade de horas para validação após o término do expediente regular do(s) funcionário(s).
                </Message>
            </div>
            <div class="p-field-checkbox">
                <Checkbox v-model="validarFechamento" @click="(disabledHorasValidarFechamento = !disabledHorasValidarFechamento)" :binary="true"/>
                <label>Validar o fechamento</label>
            </div>
            <div class="p-field">                
                <InputText v-model.number="horasValidarFechamento" type="number" placeholder="Horas para o fechamento" :disabled="disabledHorasValidarFechamento"/>
            </div>            
          </div>
        </div>

      </TabPanel>
      <TabPanel header="Configuração dos Ciclos" class="p-mt-3">       

        <Panel header="Configuração">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="descricaoCiclo">Descrição</label>
              <InputText id="descricaoCiclo" v-model.trim="descricaoCiclos" required="true" autocomplete="off"/>             
            </div>
          </div>	
        
          <DataTable :value="novosCiclos" editMode="cell" class="p-datatable-sm editable-cells-table">
            <template #header>
                <div class="table-header">                    
                    <Button icon="pi pi-plus" label="Incluir ciclo" @click="incluirCiclo()"/>
                    <Button icon="pi pi-check" class="p-ml-2" label="Salvar" @click="salvar"/>
                </div>
            </template>        
            <Column field="diasTrabalhados" header="Dias trabalhados">
              <template #editor="slotProps">
                  <InputText type="number" v-model.number="slotProps.data.diasTrabalhados" class="p-col-12 input-datatable-editavel"/>
              </template>
            </Column>
            <Column field="diasFolgas" header="Dias para folgas">
              <template #editor="slotProps">
                  <InputText type="number" v-model.number="slotProps.data.diasFolgas" class="p-col-12 input-datatable-editavel"/>
              </template>
            </Column>
            <Column field="fatorRepeticao" header="Fator de repetição">
              <template #editor="slotProps">
                  <InputText type="number" v-model.number="slotProps.data.fatorRepeticao" class="p-col-12 input-datatable-editavel"/>
              </template>
            </Column>
            <Column field="entrada1" header="1ª Entrada">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.entrada1" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":"
                     @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'entrada1')"/>
              </template>
            </Column>
            <Column field="saida1" header="1ª Saída">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.saida1" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'saida1')"/>
              </template>
            </Column>
            <Column field="entrada2" header="2ª Entrada">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.entrada2" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'entrada2')"/>
              </template>
            </Column>
            <Column field="saida2" header="2ª Saída">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.saida2" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'saida2')"/>
              </template>
            </Column>
            <Column field="entrada3" header="3ª Entrada">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.entrada3" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'entrada3')"/>
              </template>
            </Column> 
            <Column field="saida3" header="3ª Saída">
              <template #editor="slotProps">
                  <InputText type="text" v-model="slotProps.data.saida3" class="p-col-12 input-datatable-editavel p-text-center" maxlength="5" placeholder=":" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(slotProps.data, 'saida3')"/>
              </template>
            </Column>  
            <Column>
              <template #body="slotProps">
                <Button @click="excluirCiclo(slotProps.data)" title="Excluir" icon="pi pi-trash" class="p-button-rounded p-button-danger"/>
              </template>
            </Column> 
          </DataTable> 
        </Panel>          

        <Panel class="p-mt-3" header="Ciclos de Revezamento criados">
          <DataTable :value="ciclosCriados" editMode="cell" class="p-datatable-sm editable-cells-table" :style="{width: '50vw'}">                 
            <Column field="descricao" header="Descrição"></Column>
            <Column field="quantidade" header="Quantidade de ciclos"> </Column>         
            <Column>
              <template #body="slotProps">
                <Button @click="listarDetalhesCiclos(slotProps.data)" title="Detalhes" icon="pi pi-eye" class="p-button-rounded"/>
                <Button @click="confirmarExcluir(slotProps.data)" title="Excluir" icon="pi pi-trash" class="p-button-rounded p-button-danger p-ml-2"/>
              </template>
            </Column>          
          </DataTable>
        </Panel>

      </TabPanel>
    </TabView>

    <Dialog :visible.sync="exibirDialogDetalhes" header="Detalhes" :modal="true" class="p-fluid" :style="{width: '50vw'}">			
      <div class="p-fluid p-formgrid p-grid">
        <DataTable :value="detalhesCiclos" editMode="cell" class="p-datatable-sm editable-cells-table">                  
          <Column field="diasTrabalhados" header="Dias trabalhados"></Column>
          <Column field="diasFolgas" header="Dias para folgas"></Column>
          <Column field="fatorRepeticao" header="Fator de repetição"></Column>
          <Column field="entrada1" header="1ª Entrada"></Column>
          <Column field="saida1" header="1ª Saída"></Column>
          <Column field="entrada2" header="2ª Entrada"></Column>
          <Column field="saida2" header="2ª Saída"></Column>
          <Column field="entrada3" header="3ª Entrada"></Column> 
          <Column field="saida3" header="3ª Saída"></Column>          
        </DataTable> 
      </div>				
      <template #footer>       
        <Button label="OK" icon="pi pi-check" @click="exibirDialogDetalhes = false"/>
      </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
        <span>Excluir ciclo <b>{{ cicloExcluir.descricao }}</b>?</span>
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluirCicloBase" />
      </template>
    </Dialog>
      
  </div>
</template>

<script>
import ConfiguracaoEscalaService from '@/service/ConfiguracaoEscalaService';
import QuadroHorario from '@/model/QuadroHorario';
import Ciclo from '@/model/Ciclo';
import { clonar, exibirMensagem, exibirMensagemSis, formatarEtradaHora } from '@/global';
import { mapGetters } from 'vuex';

export default {
  configuracaoEscalaService: null,
  data() {
    return {
      conponenteCarregado: false,
      quadroHorario: new QuadroHorario(),
      exibirDialogConfirmarExcluir: false,
      exibirDialogDetalhes: false,
      idCicloSelecionado: null,
      descricaoCiclos: '',     
      validarFechamento: false,
      desbloquearHorasValidar: false,      
      horasValidarFechamento: null,
      disabledHorasValidarFechamento: true,
      ciclosCriados: [],
      ciclosSelecao: [],
      diasDaEscala: [],
      diasDaEscalaAux: [],
      novosCiclos: [],
      detalhesCiclos: [],
      cicloExcluir: new Ciclo(),
      parametroRefeicao: 4,
      mensagemOpcaoIntervalo: '',
      exibirMensagemOpcaoIntervalo: false,
      descontarSegundoIntervalo: false
    }
  },
  methods: {    
    ...mapGetters('sessao', ['getDadosRequisicao']),
    salvar() {
      if(this.descricaoCiclos == '') {
        exibirMensagemSis(this, 'Informe a descrição da lista de ciclos', true);
        return;
      }
      if(this.novosCiclos.length == 0) {
        exibirMensagemSis(this, 'Nenhum ciclo criado', true);
        return;
      }
      for(let i = 0; i < this.novosCiclos.length; i++) {
        let ciclo = this.novosCiclos[i];
        if(ciclo.diasTrabalhados == null || ciclo.diasTrabalhados <= 0 
            || ciclo.diasFolgas == null || ciclo.diasFolgas <= 0
            || ciclo.fatorRepeticao == null || ciclo.fatorRepeticao <= 0) {      
          exibirMensagemSis(this, 'Dados inválidos no ciclo '+(i+1), true);
          return;    
        }
      }
      let requisicao = {
        descricaoCiclos: this.descricaoCiclos,
        ciclos: clonar(this.novosCiclos),
        usuarioRequisicao: {...this.getDadosRequisicao()}
      }
      this.configuracaoEscalaService.salvarCiclos(requisicao)
				.then(resp => {			
          this.descricaoCiclo = '';
          this.novosCiclos = [];
          exibirMensagem(this, resp);
          this.listarCiclos();
        })
        .catch(erro => {exibirMensagem(this, erro)});
    },   
     listarDetalhesCiclos(ciclo) {
      let requisicao = {
        idCiclo: ciclo.id,        
        usuarioRequisicao: {...this.getDadosRequisicao()}
      }
      this.configuracaoEscalaService.listarDetalhesCiclos(requisicao)
				.then(resp => {			
          this.detalhesCiclos = resp.data;
          this.exibirDialogDetalhes = true;
        })
        .catch(erro => {exibirMensagem(this, erro)});
    },   
    listarCiclos() {
      this.configuracaoEscalaService.listarCiclos({...this.getDadosRequisicao()})
				.then(resp => {			  
          this.ciclosCriados = resp.data;       
          let cicloVazio = new Ciclo();
          cicloVazio.descricao = 'Selecione';
          this.ciclosSelecao = [];
          this.ciclosSelecao.push(cicloVazio);
          Array.prototype.push.apply(this.ciclosSelecao,resp.data);
        })
        .catch(erro => {exibirMensagem(this, erro)});
    },
    listarSequenciaCiclos(event) {
      let id = event.value;     
      if(id != null) {
        let requisicao = {
          idCiclo: id,        
          usuarioRequisicao: {...this.getDadosRequisicao()}
        }
        this.configuracaoEscalaService.listarSequenciaCiclos(requisicao)
          .then(resp => {			
            this.diasDaEscala = resp.data;
          })
          .catch(erro => {exibirMensagem(this, erro)});
      } else {
        if(this.quadroHorario.id != null) {
          this.diasDaEscala = this.diasDaEscalaAux;
        } else {
          this.diasDaEscala = [];
        }        
      }      
    },
    setConfiguracao(configuracaoEscalaHorario) {      
      this.quadroHorario = configuracaoEscalaHorario.quadroHorario;
      this.diasDaEscala = configuracaoEscalaHorario.diasDaSemana;
      this.diasDaEscalaAux = configuracaoEscalaHorario.diasDaSemana;
      this.parametroRefeicao = configuracaoEscalaHorario.parametroRefeicao;
      this.descontarSegundoIntervalo = configuracaoEscalaHorario.descontarSegundoIntervalo;
    },
    getConfiguracao() {
      if(this.diasDaEscala.length == 0) {
        throw 'Revezamento: Não foi criado uma lista de horários para o revezamento';
      }      
      if(this.validarFechamento) {
        if(this.horasValidarFechamento == null || this.horasValidarFechamento == 0) {
          throw 'Revezamento: Validar o fechamento selecionado. Informe o tempo para validar o fechamento';
        } else {
          this.quadroHorario.validarFechamento = true;
           this.quadroHorario.horasFechamento = this.horasValidarFechamento;
        }        
      } 
      let contarEdicao = 0;
      this.diasDaEscala.forEach(dia => {
        if(dia.id == null) {
          contarEdicao++;
        }
      });      
      if(this.quadroHorario.id == null) {
        this.quadroHorario = new QuadroHorario();
      }
      this.quadroHorario.tipoEscala = 'ERC';      
      let definicaoHoraio = {
        quadroHorario: clonar(this.quadroHorario),
        diasDaSemana: clonar(this.diasDaEscala),
        diasDaSemanaExcluir: [],
        parametroRefeicao: this.parametroRefeicao, // Esse atriburo está no obj PoliticaContratual.
        descontarSegundoIntervalo: this.descontarSegundoIntervalo // Esse atriburo está no obj PoliticaContratual.
      }
      if(contarEdicao > 0) {
        definicaoHoraio.diasDaSemanaExcluir = clonar(this.diasDaEscalaAux);
      }
      return definicaoHoraio;
    },
    excluirCicloBase() {
      let requisicao = {
        ciclo: {...this.cicloExcluir},        
        usuarioRequisicao: {...this.getDadosRequisicao()}
      }
      this.configuracaoEscalaService.excluirCiclos(requisicao)
        .then(resp => {		
          exibirMensagem(this, resp);
          this.limparExcluir();
          this.listarCiclos();
        })
        .catch(erro => {exibirMensagem(this, erro)});
    },
    incluirCiclo() {
      this.novosCiclos.push(new Ciclo());
    },
    excluirCiclo(ciclo) {    
      this.novosCiclos.splice(this.novosCiclos.indexOf(ciclo), 1);
    },
    confirmarExcluir(ciclo) {
			this.cicloExcluir = ciclo;
			this.exibirDialogConfirmarExcluir = true;
		},
    limparExcluir() {
      this.cicloExcluir = new Ciclo();
			this.exibirDialogConfirmarExcluir = false;
    },
    limparEntradaHoraInvalida(data, campo) {
      if(data[campo] == null) {
        return;
      }
      let regex = /[0-2][0-9]:[0-5][0-9]/g;
      if(!data[campo].match(regex)) {
        data[campo] = '';
      }
    },
    validarEntraHora(event) {
      formatarEtradaHora(event);
    },
    validarOpcaoIntervalo(opcao) {
      if(opcao == 3) {
        this.exibirMensagemOpcaoIntervalo = true;
        this.mensagemOpcaoIntervalo = 'Marcação Pré-assinalada para a Refeição: configure os horários nos campos 1ª Saída e 2ª Entrada. Não selecionar horário flexivel!';
        setTimeout(() => { this.exibirMensagemOpcaoIntervalo = false }, 60000);
      } else if(opcao == 2) {
        this.exibirMensagemOpcaoIntervalo = true;
        this.mensagemOpcaoIntervalo = 'Marcação Inexistente para a Refeição: configure os horários somente nos campos 1ª Entrada e 1ª Saída';
        setTimeout(() => { this.exibirMensagemOpcaoIntervalo = false }, 60000);      
      } else {
        this.exibirMensagemOpcaoIntervalo = false;
        this.mensagemOpcaoIntervalo = '';
      }
    },
    carregado() {
      return this.conponenteCarregado;
    }
  },
  created() {
    this.configuracaoEscalaService = new ConfiguracaoEscalaService();
    let cicloVazio = new Ciclo();
    cicloVazio.descricao = 'Selecione';
    this.ciclosSelecao = [];
    this.ciclosSelecao.push(cicloVazio);
  },
  mounted() {
    this.listarCiclos();
    this.conponenteCarregado = true;
  }
}
</script>

<style>

</style>